import React from 'react';
import Header from './Components/home/Header';
import GridPanel from "./Components/home/GridPanel"
const App = () => {
  return (
    <div>
      <Header />
      <GridPanel />
    </div>
  );
}

export default App;
